import React, { useState } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import { App, Button } from 'antd';

import { saveAs } from 'file-saver';
import { formatDate } from 'helpers/date';
import { tap } from 'rxjs/operators';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import ordersService from 'v2/services/orders';

import { Icon } from '@eduzz/ui-antd-theme';

export const Export = () => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState<boolean>(false);

  const [totalItems] = useObservable(() => ordersService.getTotalItems(), []);

  const [exportReport] = useCallbackObservable(() => {
    setLoading(true);
    return ordersService.export().pipe(
      tap(orders => {
        try {
          const dateExport = formatDate(new Date(), 'dd-MM-yyyy');
          const fileExport = new Blob([orders as Blob], { type: 'text/csv; charset=utf-8' });
          saveAs(fileExport, `minhas-entregas-${dateExport}.csv`);
          setLoading(false);
        } catch (e) {
          message.error(typeof e === 'string' ? e : 'Não foi possível exportar as entregas.');
        } finally {
          setLoading(false);
        }
      })
    );
  }, [message]);

  return (
    <div>
      <PermissionHide action='myeduzz:minhas-entregas:exportar'>
        <Button
          color='default'
          variant='filled'
          disabled={!totalItems || loading}
          onClick={exportReport}
          loading={loading}
          icon={<Icon.Download size={16} />}
        >
          {!loading ? 'Exportar' : 'Exportando...'}
        </Button>
      </PermissionHide>
    </div>
  );
};
